import { c as _c } from "react/compiler-runtime";
import { SPACE_ELEMENTS_OF_MODAL } from "@components/common/dialog/dialog-constants";
import { InviteMemberButton } from "@components/common/invite-member-button";
import { MembersAutocomplete } from "@components/common/members-autocomplete/members-autocomplete";
import { XgSeatCheckbox } from "@components/table/members/assign-seats/xg-seat-checkbox";
import { ProjectRoleAutoComplete } from "@components/role/role-autocomplete/project-role-autocomplete";
import { Dialog } from "@flat-ui";
import { useInviteMembersToProject } from "@hooks/projects/use-invite-members-to-project";
import { Stack } from "@mui-wrapper";
import { INVITE_DIALOG_CLOSE_DELAY_MS } from "@src/constants/invite-constants";
import { delay } from "@utils/time-utils";
import { useState } from "react";
/** Renders the invite member button and the functionality in project overview */
export function InviteMemberToProject(t0) {
  const $ = _c(37);
  const {
    project,
    buttonVariant: t1
  } = t0;
  const buttonVariant = t1 === undefined ? "outlined" : t1;
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = async () => {
      setIsDialogOpen(false);
      await delay(INVITE_DIALOG_CLOSE_DELAY_MS);
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== project) {
    t3 = {
      project,
      location: "invite-member-to-project",
      initialRole: "RESOURCE_VIEWER",
      onInviteSuccess: t2
    };
    $[1] = project;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const {
    autocompleteOptions,
    selectedMembers,
    helperText,
    handleMemberSelect,
    onInputChange,
    isValidInput,
    getChipColor,
    giveXgSeatsCheckbox,
    selectedRole,
    setSelectedRole,
    canAssignProjectRoles,
    isLoading,
    shouldSendInviteDisable,
    handleConfirm,
    reset
  } = useInviteMembersToProject(t3);
  let t4;
  if ($[3] !== reset) {
    t4 = function onOpenInviteDialog() {
      reset();
      setIsDialogOpen(true);
    };
    $[3] = reset;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const onOpenInviteDialog = t4;
  let t5;
  if ($[5] !== buttonVariant || $[6] !== onOpenInviteDialog) {
    t5 = <InviteMemberButton buttonVariant={buttonVariant} onClick={onOpenInviteDialog} />;
    $[5] = buttonVariant;
    $[6] = onOpenInviteDialog;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = canAssignProjectRoles ? "Invite members to project" : "Invite viewers to project";
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setIsDialogOpen(false);
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== canAssignProjectRoles || $[10] !== isLoading || $[11] !== selectedRole || $[12] !== setSelectedRole) {
    t8 = canAssignProjectRoles && <Stack sx={{
      marginBottom: SPACE_ELEMENTS_OF_MODAL
    }}><ProjectRoleAutoComplete isRequired={true} selectedRole={selectedRole} onChange={role => setSelectedRole(role)} isDisabled={isLoading} /></Stack>;
    $[9] = canAssignProjectRoles;
    $[10] = isLoading;
    $[11] = selectedRole;
    $[12] = setSelectedRole;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== autocompleteOptions || $[15] !== getChipColor || $[16] !== handleMemberSelect || $[17] !== helperText || $[18] !== isLoading || $[19] !== isValidInput || $[20] !== onInputChange || $[21] !== selectedMembers) {
    t9 = <MembersAutocomplete isRequired={true} hasAutoFocus={true} label="Members" helperText={helperText} onInputChange={onInputChange} options={autocompleteOptions} selectedOptions={selectedMembers} handleMemberSelect={handleMemberSelect} isValid={isValidInput} getChipColor={getChipColor} isDisabled={isLoading} />;
    $[14] = autocompleteOptions;
    $[15] = getChipColor;
    $[16] = handleMemberSelect;
    $[17] = helperText;
    $[18] = isLoading;
    $[19] = isValidInput;
    $[20] = onInputChange;
    $[21] = selectedMembers;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== giveXgSeatsCheckbox) {
    t10 = giveXgSeatsCheckbox && <XgSeatCheckbox {...giveXgSeatsCheckbox} />;
    $[23] = giveXgSeatsCheckbox;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== handleConfirm || $[26] !== isDialogOpen || $[27] !== isLoading || $[28] !== shouldSendInviteDisable || $[29] !== t10 || $[30] !== t6 || $[31] !== t8 || $[32] !== t9) {
    t11 = <Dialog title={t6} confirmText="Send Invite" open={isDialogOpen} onConfirm={handleConfirm} showSpinner={isLoading} isConfirmDisabled={shouldSendInviteDisable} onCancel={t7} dataTestId="invite-members-to-project-dialog">{t8}{t9}{t10}</Dialog>;
    $[25] = handleConfirm;
    $[26] = isDialogOpen;
    $[27] = isLoading;
    $[28] = shouldSendInviteDisable;
    $[29] = t10;
    $[30] = t6;
    $[31] = t8;
    $[32] = t9;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  let t12;
  if ($[34] !== t11 || $[35] !== t5) {
    t12 = <>{t5}{t11}</>;
    $[34] = t11;
    $[35] = t5;
    $[36] = t12;
  } else {
    t12 = $[36];
  }
  return t12;
}